const GalleryItemModel = {
  position: 1,
  title: { pl: '', en: '' },
  description: { pl: '', en: '' },
  file: {
    base64: '',
    fileName: '',
    delete: false,
  },
};

export default GalleryItemModel;
